<ion-backdrop [class.backdrop-no-tappable]="true" [visible]="showBackdrop"></ion-backdrop>
<div class="loading-wrapper" [ngClass]="cssClass">
  <ion-spinner class="loading-spinner" [name]="spinnerType" role="progressbar"></ion-spinner>
  <p class="loading-text">{{ message }}</p>
</div>
